/**
 * @generated SignedSource<<784a94afb9978b647fd696de1b30e6e2>>
 * @relayHash 2f4d56d2b402dd52392cc052bfedf18c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/567.0.0-2026-07-02T08:38:46.240Z/useNotificationsDeleteTagsAllMutation

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserNotificationsTagEnum = "UNREAD" | "UNVIEWED" | "%future added value";
export type UserNotificationsDeleteTagsInput = {
  activityFeedTagIds?: ReadonlyArray<string | null> | null;
  clientMutationId?: string | null;
  conversationIds?: ReadonlyArray<string | null> | null;
  itemEventTagIds?: ReadonlyArray<string | null> | null;
  tag?: UserNotificationsTagEnum | null;
  userId?: string | null;
};
export type useNotificationsDeleteTagsAllMutation$variables = {
  hasTradeUserId: boolean;
  input: UserNotificationsDeleteTagsInput;
  priceBookName: string;
  showPriceDropNotifications?: boolean | null;
  userCountryCode: string;
  userId: string;
};
export type useNotificationsDeleteTagsAllMutation$data = {
  readonly userNotificationsDeleteTags: {
    readonly viewer: {
      readonly " $fragmentSpreads": FragmentRefs<"UserNotificationsIcon_viewer" | "UserNotificationsMarkAllAsRead_viewer" | "UserNotificationsTabs_viewer">;
    };
  } | null;
};
export type useNotificationsDeleteTagsAllMutation = {
  response: useNotificationsDeleteTagsAllMutation$data;
  variables: useNotificationsDeleteTagsAllMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasTradeUserId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showPriceDropNotifications"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v6 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v7 = {
  "kind": "Variable",
  "name": "showPriceDropNotifications",
  "variableName": "showPriceDropNotifications"
},
v8 = [
  (v7/*:: as any*/)
],
v9 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notificationType",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v14 = [
  (v12/*:: as any*/),
  (v13/*:: as any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNotificationsTag",
  "kind": "LinkedField",
  "name": "unreadTag",
  "plural": false,
  "selections": (v14/*:: as any*/),
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNotificationsTag",
  "kind": "LinkedField",
  "name": "unviewedTag",
  "plural": false,
  "selections": [
    (v12/*:: as any*/),
    (v13/*:: as any*/),
    (v11/*:: as any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "thumb"
    }
  ],
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"thumb\")"
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Item",
  "kind": "LinkedField",
  "name": "item",
  "plural": false,
  "selections": [
    (v12/*:: as any*/),
    (v19/*:: as any*/),
    (v20/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localizedPdpUrl",
      "storageKey": null
    },
    (v13/*:: as any*/)
  ],
  "storageKey": null
},
v22 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "hasTradeUserId"
},
v23 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v26 = [
  (v24/*:: as any*/),
  (v25/*:: as any*/)
],
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": (v26/*:: as any*/),
  "storageKey": null
},
v28 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            (v22/*:: as any*/),
            {
              "kind": "Literal",
              "name": "page",
              "value": "favorites"
            },
            (v23/*:: as any*/)
          ],
          "concreteType": "ItemDisplayPriceType",
          "kind": "LinkedField",
          "name": "displayPrice",
          "plural": true,
          "selections": [
            (v27/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ConvertedAmountList",
              "kind": "LinkedField",
              "name": "originalConvertedAmountList",
              "plural": true,
              "selections": (v26/*:: as any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "percentageOff",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RetailPriceHistoryItem",
              "kind": "LinkedField",
              "name": "retailPriceHistory",
              "plural": true,
              "selections": [
                (v18/*:: as any*/),
                (v27/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PriceDropFavoriteNotification",
  "abstractKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Item",
  "kind": "LinkedField",
  "name": "item",
  "plural": false,
  "selections": [
    (v19/*:: as any*/),
    (v20/*:: as any*/),
    (v13/*:: as any*/)
  ],
  "storageKey": null
},
v30 = [
  (v25/*:: as any*/),
  (v24/*:: as any*/)
],
v31 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "convertedAmountList",
    "plural": true,
    "selections": (v30/*:: as any*/),
    "storageKey": null
  }
],
v32 = [
  (v13/*:: as any*/)
],
v33 = {
  "kind": "InlineFragment",
  "selections": (v32/*:: as any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Anchor",
  "kind": "LinkedField",
  "name": "anchors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "source",
      "plural": false,
      "selections": [
        (v11/*:: as any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "token",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Transaction",
              "kind": "LinkedField",
              "name": "transaction",
              "plural": false,
              "selections": [
                (v29/*:: as any*/),
                (v13/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "OrderFeedback",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LoyaltyProgram",
              "kind": "LinkedField",
              "name": "programInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                },
                (v13/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "ParentProgram",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "rewardEarned",
              "plural": false,
              "selections": (v30/*:: as any*/),
              "storageKey": null
            }
          ],
          "type": "TradeFirmReward",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v12/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "TransactionSummaryObject",
              "kind": "LinkedField",
              "name": "summary",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "offerDiscountPercentage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "item",
              "plural": false,
              "selections": [
                (v12/*:: as any*/),
                (v19/*:: as any*/),
                (v20/*:: as any*/),
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "buyerId",
                      "variableName": "userId"
                    },
                    (v22/*:: as any*/),
                    (v23/*:: as any*/),
                    {
                      "kind": "Variable",
                      "name": "userCountryCode",
                      "variableName": "userCountryCode"
                    }
                  ],
                  "concreteType": "ItemDisplayPriceType",
                  "kind": "LinkedField",
                  "name": "displayPrice",
                  "plural": true,
                  "selections": (v31/*:: as any*/),
                  "storageKey": null
                },
                (v13/*:: as any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Offer",
              "kind": "LinkedField",
              "name": "mostRecentOffer",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "amountPerItem",
                  "plural": false,
                  "selections": (v31/*:: as any*/),
                  "storageKey": null
                },
                (v13/*:: as any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Conversation",
              "kind": "LinkedField",
              "name": "conversation",
              "plural": false,
              "selections": (v14/*:: as any*/),
              "storageKey": null
            }
          ],
          "type": "Transaction",
          "abstractKey": null
        },
        (v33/*:: as any*/),
        {
          "kind": "InlineFragment",
          "selections": (v32/*:: as any*/),
          "type": "Category",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasUnviewedTag",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasUnreadTag",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "Member",
  "kind": "LinkedField",
  "name": "buyerMember",
  "plural": false,
  "selections": [
    (v35/*:: as any*/),
    (v36/*:: as any*/),
    (v13/*:: as any*/)
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestMessage",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestMessageReceivedAt",
  "storageKey": null
},
v40 = {
  "kind": "InlineFragment",
  "selections": [
    (v12/*:: as any*/)
  ],
  "type": "PriceDropFavoriteNotification",
  "abstractKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNotification",
  "kind": "LinkedField",
  "name": "all",
  "plural": true,
  "selections": [
    (v10/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "payload",
      "plural": false,
      "selections": [
        (v11/*:: as any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v12/*:: as any*/),
            (v15/*:: as any*/),
            (v16/*:: as any*/),
            (v17/*:: as any*/),
            (v18/*:: as any*/),
            (v21/*:: as any*/),
            (v28/*:: as any*/)
          ],
          "type": "FavoriteNotification",
          "abstractKey": "__isFavoriteNotification"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v12/*:: as any*/),
            (v15/*:: as any*/),
            (v16/*:: as any*/),
            (v17/*:: as any*/),
            (v18/*:: as any*/),
            (v34/*:: as any*/)
          ],
          "type": "ActivityFeedElement",
          "abstractKey": null
        },
        (v33/*:: as any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v12/*:: as any*/),
            (v37/*:: as any*/),
            (v38/*:: as any*/),
            (v39/*:: as any*/),
            (v29/*:: as any*/)
          ],
          "type": "Conversation",
          "abstractKey": null
        },
        (v40/*:: as any*/)
      ],
      "storageKey": null
    },
    (v11/*:: as any*/)
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNotificationsTag",
  "kind": "LinkedField",
  "name": "unviewedTag",
  "plural": false,
  "selections": [
    (v11/*:: as any*/),
    (v13/*:: as any*/)
  ],
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "favorites",
  "plural": true,
  "selections": [
    (v11/*:: as any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isFavoriteNotification"
    },
    (v12/*:: as any*/),
    (v16/*:: as any*/),
    (v18/*:: as any*/),
    (v15/*:: as any*/),
    (v42/*:: as any*/),
    (v21/*:: as any*/),
    (v28/*:: as any*/),
    (v33/*:: as any*/)
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "ActivityFeedElement",
  "kind": "LinkedField",
  "name": "other",
  "plural": true,
  "selections": [
    (v12/*:: as any*/),
    (v16/*:: as any*/),
    (v18/*:: as any*/),
    (v15/*:: as any*/),
    (v42/*:: as any*/),
    (v34/*:: as any*/),
    (v13/*:: as any*/)
  ],
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNotification",
  "kind": "LinkedField",
  "name": "offers",
  "plural": true,
  "selections": [
    (v10/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "payload",
      "plural": false,
      "selections": [
        (v11/*:: as any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v12/*:: as any*/),
            (v16/*:: as any*/),
            (v18/*:: as any*/),
            (v15/*:: as any*/),
            (v42/*:: as any*/),
            (v34/*:: as any*/)
          ],
          "type": "ActivityFeedElement",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v12/*:: as any*/),
            (v16/*:: as any*/),
            (v18/*:: as any*/),
            (v15/*:: as any*/),
            (v42/*:: as any*/),
            (v21/*:: as any*/),
            (v28/*:: as any*/)
          ],
          "type": "FavoriteNotification",
          "abstractKey": "__isFavoriteNotification"
        },
        (v40/*:: as any*/),
        (v33/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useNotificationsDeleteTagsAllMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*:: as any*/),
        "concreteType": "UserNotificationsDeleteTagsPayload",
        "kind": "LinkedField",
        "name": "userNotificationsDeleteTags",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "args": (v8/*:: as any*/),
                "kind": "FragmentSpread",
                "name": "UserNotificationsMarkAllAsRead_viewer"
              },
              {
                "args": (v8/*:: as any*/),
                "kind": "FragmentSpread",
                "name": "UserNotificationsIcon_viewer"
              },
              {
                "args": (v8/*:: as any*/),
                "kind": "FragmentSpread",
                "name": "UserNotificationsTabs_viewer"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useNotificationsDeleteTagsAllMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*:: as any*/),
        "concreteType": "UserNotificationsDeleteTagsPayload",
        "kind": "LinkedField",
        "name": "userNotificationsDeleteTags",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v7/*:: as any*/),
                  (v9/*:: as any*/)
                ],
                "concreteType": "UserNotifications",
                "kind": "LinkedField",
                "name": "userNotifications",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserNotificationsBucket",
                    "kind": "LinkedField",
                    "name": "latest",
                    "plural": false,
                    "selections": [
                      (v41/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Conversation",
                        "kind": "LinkedField",
                        "name": "messages",
                        "plural": true,
                        "selections": [
                          (v12/*:: as any*/),
                          (v13/*:: as any*/),
                          (v37/*:: as any*/),
                          (v38/*:: as any*/),
                          (v39/*:: as any*/),
                          (v29/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v43/*:: as any*/),
                      (v44/*:: as any*/),
                      (v45/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserNotificationsBucket",
                    "kind": "LinkedField",
                    "name": "earlier",
                    "plural": false,
                    "selections": [
                      (v41/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Conversation",
                        "kind": "LinkedField",
                        "name": "messages",
                        "plural": true,
                        "selections": [
                          (v12/*:: as any*/),
                          (v38/*:: as any*/),
                          (v39/*:: as any*/),
                          (v29/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Member",
                            "kind": "LinkedField",
                            "name": "buyerMember",
                            "plural": false,
                            "selections": [
                              (v36/*:: as any*/),
                              (v35/*:: as any*/),
                              (v13/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v13/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v43/*:: as any*/),
                      (v44/*:: as any*/),
                      (v45/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v9/*:: as any*/)
                ],
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Promotion",
                    "kind": "LinkedField",
                    "name": "activePromotion",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "buyerDisplayable",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PromotionMeta",
                        "kind": "LinkedField",
                        "name": "promotionMeta",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayMessage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayCta",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "adjustmentRateList",
                        "plural": true,
                        "selections": [
                          (v11/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "reference",
                            "storageKey": null
                          },
                          (v33/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlatAdjustmentRate",
                        "kind": "LinkedField",
                        "name": "flatAdjustmentRate",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "rate",
                            "plural": false,
                            "selections": (v30/*:: as any*/),
                            "storageKey": null
                          },
                          (v13/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PercentAdjustmentRate",
                        "kind": "LinkedField",
                        "name": "percentAdjustmentRate",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rate",
                            "storageKey": null
                          },
                          (v13/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v13/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v13/*:: as any*/)
                ],
                "storageKey": null
              },
              (v13/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/567.0.0-2026-07-02T08:38:46.240Z/useNotificationsDeleteTagsAllMutation",
    "metadata": {},
    "name": "useNotificationsDeleteTagsAllMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "6a8a9ee5d34acc0e284975482e340ad1";

export default node;
